import { render, staticRenderFns } from "./FreeProducts.vue?vue&type=template&id=6015ee66&scoped=true&"
import script from "./FreeProducts.vue?vue&type=script&lang=js&"
export * from "./FreeProducts.vue?vue&type=script&lang=js&"
import style0 from "./FreeProducts.vue?vue&type=style&index=0&id=6015ee66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015ee66",
  null
  
)

export default component.exports